import { observer } from '@formily/react';
import { PropsWithComponentData, useComponentData, useSchemaItemsToItems } from '@yimoka/react';
import { IAny } from '@yimoka/shared';
import { Steps as AntSteps, StepsProps } from 'antd';
import React, { useMemo } from 'react';

import { strToIcon } from '../tools/icon';

const propsMap = { title: 'title' };

const StepsFC = observer((props: PropsWithComponentData<StepsProps> & { value?: IAny[], }) => {
  const { items, value, data, dataKey, store, ...rest } = props;
  const curData = useComponentData([data, value], dataKey, store);
  const schemaItems = useSchemaItemsToItems(curData, propsMap, 'title');
  const curItems = useMemo(() => [...(items ?? []), ...(schemaItems ?? [])]?.map(item => (typeof item.icon === 'string' ? { ...item, icon: strToIcon(item.icon) } : item)), [items, schemaItems]);

  return <AntSteps  {...rest} items={curItems} />;
});

export const Steps = Object.assign(StepsFC, {});

export type { StepsProps };
